export default __webpack_public_path__ + "static/media/btn-stage1.8fd2cc23.png";